"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.makeSizeStyles = exports.Sizes = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var polished_1 = require("polished");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var fallback_1 = require("./fallback");

var image_1 = require("./image");

var isInFocus = ui_blocks_1.INTERACTIVE.isInFocus;
var Sizes;

(function (Sizes) {
  Sizes[Sizes["tiny"] = 3] = "tiny";
  Sizes[Sizes["small"] = 4] = "small";
  Sizes[Sizes["medium"] = 5] = "medium";
  Sizes[Sizes["large"] = 6] = "large";
  Sizes[Sizes["huge"] = 7] = "huge";
  Sizes[Sizes["gigantic"] = 8] = "gigantic";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var makeSizeStyles = function makeSizeStyles(size, theme) {
  var _a, _b;

  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP), (0, ui_symbols_1.calcSpace)(Sizes[size], (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP));
};

exports.makeSizeStyles = makeSizeStyles;
var borderStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border: 0.125rem solid\n    ", ";\n"], ["\n  border: 0.125rem solid\n    ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
exports.Root = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  display: inline-flex;\n  border-radius: 50%;\n  height: ", ";\n  width: ", ";\n  ", ";\n\n  ", ", ", " {\n    ", ";\n  }\n\n  &[href]:focus {\n    ", "\n\n    &::before {\n      height: calc(100% + ", ");\n      width: calc(100% + ", ");\n      top: ", ";\n      left: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  border-radius: 50%;\n  height: ", ";\n  width: ", ";\n  ", ";\n\n  ", ", ", " {\n    ", ";\n  }\n\n  &[href]:focus {\n    ", "\n\n    &::before {\n      height: calc(100% + ", ");\n      width: calc(100% + ", ");\n      top: ", ";\n      left: ", ";\n    }\n  }\n"])), function (_a) {
  var scale = _a.scale;
  return scale && (0, ui_symbols_1.calcSpace)(scale);
}, function (_a) {
  var scale = _a.scale;
  return scale && (0, ui_symbols_1.calcSpace)(scale);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'size', exports.makeSizeStyles);
}, image_1.Image, fallback_1.Fallback, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'withBorder', borderStyles);
}, isInFocus, (0, polished_1.rem)(6), (0, polished_1.rem)(6), (0, polished_1.rem)(-3), (0, polished_1.rem)(-3));
var templateObject_1, templateObject_2, templateObject_3;